import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth'

/**
 * Client-side route guard.
 *
 * Important framing, and it is Module 8, Lesson 6: this component is a
 * CONVENIENCE, not a security control. It stops an unauthenticated user from
 * seeing a broken page — it does not protect data. Anyone can edit their own
 * JavaScript. The actual protection is the `if (!user) throw unauthorized()`
 * on every server route, which runs on a machine the user does not control.
 *
 * If this file were deleted, the app would look worse and leak nothing.
 */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <div className="loading">Checking your session…</div>
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />
  return <>{children}</>
}
